import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityCreteilPage() {
  const data = citiesData.find((c) => c.slug === "creteil")!;
  return <CityPage data={data} />;
}
